import {BaseSyntheticEvent, FC, ReactNode, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import {GET, POST, PUT} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {useNavigate} from 'react-router-dom'
import useAuth from '../../../../hooks/useAuth'
import {i18n} from '../../../../translate/i18n'
import uuid from 'react-uuid'
import {removeEspacosEmBranco} from '../../../../utils/formater'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {CardInfoGuide, CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'
import {
  availabilityInfo,
  attributesInfo,
  dimensionsInfo,
  identificationInfo,
  pricesInfo,
  statusInfo,
  stockInfo,
} from './cardInfoContent'

type ProductTypeResponse = {
  id: number
  name: string
}

type LocationTypeResponse = {
  id: number
  name: string
  type?: string
}

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
}

type SelectType = {
  value: string
  label: string
}

type CollapsibleCardProps = {
  title: string
  children: ReactNode
  defaultOpen?: boolean
  infoContent?: CardInfoContent
  infoInteraction?: 'click' | 'hover' | 'both'
}

const CollapsibleCard: FC<CollapsibleCardProps> = ({
  title,
  children,
  defaultOpen = true,
  infoContent,
  infoInteraction = 'click',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className='card pb-5 mb-5'>
      <div className='card-header py-5 d-flex justify-content-between align-items-center'>
        <h3 className='card-title align-items-start flex-column mb-0'>
          <span className='card-label fw-bold fs-4 mb-1'>{title}</span>
        </h3>
        <div className='d-flex align-items-center gap-2'>
          {infoContent && <CardInfoGuide content={infoContent} interaction={infoInteraction} />}
          <button
            type='button'
            className='btn btn-sm btn-icon variation-card-toggle'
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? 'Fechar card' : 'Abrir card'}
          >
            <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
          </button>
        </div>
      </div>
      <div
        style={{
          maxHeight: isOpen ? '2200px' : '0px',
          opacity: isOpen ? 1 : 0,
          overflow: isOpen ? 'visible' : 'hidden',
          transition: 'max-height 0.35s ease, opacity 0.25s ease',
        }}
      >
        <div className='px-10 py-5'>{children}</div>
      </div>
    </div>
  )
}

const CriarVariacoesContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const {loginInfo} = useAuth()
  const [status, setStatus] = useState<boolean>(true)
  const [showPromotionalPrice, setShowPromotionalPrice] = useState<boolean>(true)
  const [products, setProducts] = useState<ProductTypeResponse[]>([])
  const [locations, setLocations] = useState<LocationTypeResponse[]>([])
  const [productId, setProductId] = useState<number>(0)
  const [productSelected, setProductSelected] = useState<SelectType>({
    value: '0',
    label: 'Selecione um produto',
  })
  const [locationId, setLocationId] = useState<number>(0)
  const [selectedGrid, setSelectedGrid] = useState('')
  const [grids, setGrids] = useState<GridTypeResponse[]>([])
  const [gridList, setGridList] = useState<GridTypeResponse[]>([])
  const [gridConfirmed, setGridConfirmed] = useState(false)

  const [image, setImage] = useState<File | null>(null)
  const [sku, setSku] = useState('')
  const [referenceCode, setReferenceCode] = useState('')
  const [colorCode, setColorCode] = useState('')
  const [gtin, setGtin] = useState('')
  const [mpn, setMpn] = useState('')
  const [ncm, setNcm] = useState('')
  const [costPrice, setCostPrice] = useState(0)
  const [price, setPrice] = useState(0)
  const [promotionalPrice, setPromotionalPrice] = useState(0)
  const [weight, setWeight] = useState(0)
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)
  const [deep, setDeep] = useState(0)
  const [stockSituation, setStockSituation] = useState(0)
  const [outStockSituation, setOutStockSituation] = useState(0)
  const [inventory, setInventory] = useState(0)
  const [minStock, setMinStock] = useState(0)
  const [gridSelected, setGridSelected] = useState<any>({})

  const [variationNone, setVariationNone] = useState(false)
  const [canAlert, setCanAlert] = useState(false)

  const getLocations = async () => {
    try {
      const locationRes = await GET('/location')
      const newLocations = [
        {
          id: 0,
          name: i18n.t(`smart_order.select_modality`),
        },
      ]
      locationRes.data.forEach((location: LocationTypeResponse) => {
        if (location.type !== 'address') {
          newLocations.push({
            id: location.id,
            name: location.name,
          })
        }
      })
      setLocations(newLocations)
    } catch (e) {
      console.log(e)
    }
  }

  const getProducts = async () => {
    try {
      const productRes = await GET('/product')
      const newProducts = [
        {
          id: 0,
          name: i18n.t(`smart_order.select_product`),
        },
      ]
      productRes.data.forEach((product: ProductTypeResponse) => {
        newProducts.push({
          id: product.id,
          name: product.name,
        })
      })
      setProducts(newProducts)
    } catch (e) {
      console.log(e)
    }
  }

  const getGrids = async () => {
    try {
      const gridRes = await GET('/grid')
      const newGrids: GridTypeResponse[] = []
      gridRes.data.forEach((grid: GridTypeResponse) => {
        grid.status &&
          newGrids.push({
            id: grid.id,
            name: grid.name,
            variation: grid.variation,
          })
      })
      setGrids(newGrids)
    } catch (e) {
      console.log(e)
    }
  }

  const addToGridList = () => {
    const gridFinded = gridList.find((grid) => grid.id === parseInt(selectedGrid))
    if (!gridFinded) {
      const newGridList = gridList
      const newGrid = grids.find((grid) => grid.id === parseInt(selectedGrid))
      if (newGrid) {
        newGridList.push(newGrid)
        setGridList(newGridList)
        setSelectedGrid('')
      }
    }
  }

  const removeToGridList = (idGrid: number) => {
    const newGridList = gridList.filter((grid) => grid.id !== idGrid)
    setGridList(newGridList)
    setSelectedGrid('')
  }

  const confirmGrid = () => {
    if (!productId || !locationId) {
      Swal.fire({
        icon: 'error',
        title: 'Campos faltantes',
        text: 'Verifique se selecionou produto e modalidade!',
      })
    } else {
      if (gridList.length > 0) {
        setGridConfirmed(true)
        let gridMaked = gridSelected
        gridList.forEach((grid) => {
          const gridVariation = Object.entries(JSON.parse(grid.variation))[0]
          gridMaked[grid.name] = gridVariation[1]
        })

        setGridSelected(gridMaked)
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Nenhuma grade adicionada',
        })
      }
    }
  }

  const createVariation = async () => {
    try {
      if (!productId || !locationId || !sku || !price) {
        setCanAlert(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        setLoading(true)
        let imageRes = {
          success: false,
          image: '',
        }

        const variationRes = await POST('/variations', {
          locationId,
          productId,
          sku: removeEspacosEmBranco(sku),
          price,
          status,
          showPromotionalPrice,
          inventory,
          minimumStock: minStock,
          gtin,
          mpn,
          ncm,
          costPrice,
          promotionalPrice,
          width,
          height,
          weight,
          depth: deep,
          referenceCode,
          colorCode,
          context: Object.entries(gridSelected).map((variation) => ({
            cod_desc: variation[0],
            value: variation[1],
          })),
          img: imageRes.success ? imageRes.image : '',
        })
        if (image) {
          const formData = new FormData()
          formData.append('file', image)
          formData.append('nameImage', `variation-${uuid()}.jpg`)
          imageRes = await POST('/upload-images/upload-one', formData)
          if (imageRes.success) {
            await PUT(`/variations/${variationRes.dados.id}`, {
              img: imageRes.image,
            })
          }
        }

        setLoading(false)
        if (variationRes.success === true) {
          setCanAlert(false)
          Swal.fire({
            icon: 'success',
            title: 'Variação cadastrada',
            text: 'Cadastro realizado com sucesso!',
          }).then(() => navigate(`/variation`))
        } else {
          setCanAlert(true)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar a variação!',
          })
        }
      }
      return
    } catch (e) {
      setCanAlert(true)
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar a variação!',
      })
    }
  }

  const makeVariationContext = (gridName: string, valueVariation: string) => {
    let gridMaked = gridSelected
    gridMaked[gridName] = valueVariation
    setGridSelected(gridMaked)
  }

  const generateSKU = () => {
    const possible = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let text = ''
    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    text += productId.toString()
    setSku(text)
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('variation-saved')
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const load = async () => {
      if (loginInfo.plugintype !== 'fashion') {
        setVariationNone(true)
      }
      setLoading(true)
      await getProducts()
      await getLocations()
      await getGrids()
      setLoading(false)
    }

    const variationSaved = localStorage.getItem('variation-saved')
    if (variationSaved && JSON.parse(variationSaved)) loadLocal()
    else load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      if (canAlert && !window.location.pathname.includes(`/variation/criar`)) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(`/variation/criar`)
          } else {
            localStorage.removeItem('variation-saved')
          }
        })
      } else if (!canAlert) localStorage.removeItem('variation-saved')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, canAlert])

  const loadLocal = () => {
    const variationSaved = localStorage.getItem('variation-saved')
    if (variationSaved && JSON.parse(variationSaved)) {
      const jsonVariation = JSON.parse(variationSaved)
      setStatus(jsonVariation.status)
      setShowPromotionalPrice(jsonVariation.showPromotionalPrice)
      setProducts(jsonVariation.products)
      setLocations(jsonVariation.locations)
      setProductId(jsonVariation.productId)
      setProductSelected(jsonVariation.productSelected)
      setLocationId(jsonVariation.locationId)
      setSelectedGrid(jsonVariation.selectedGrid)
      setGrids(jsonVariation.grids)
      setGridList(jsonVariation.gridList)
      setGridConfirmed(jsonVariation.gridConfirmed)
      setSku(jsonVariation.sku)
      setReferenceCode(jsonVariation.referenceCode)
      setColorCode(jsonVariation.colorCode)
      setGtin(jsonVariation.gtin)
      setMpn(jsonVariation.mpn)
      setNcm(jsonVariation.ncm)
      setCostPrice(jsonVariation.costPrice)
      setPrice(jsonVariation.price)
      setPromotionalPrice(jsonVariation.promotionalPrice)
      setWeight(jsonVariation.weight)
      setHeight(jsonVariation.height)
      setWidth(jsonVariation.width)
      setDeep(jsonVariation.deep)
      setStockSituation(jsonVariation.stockSituation)
      setOutStockSituation(jsonVariation.outStockSituation)
      setInventory(jsonVariation.inventory)
      setMinStock(jsonVariation.minStock)
      setGridSelected(jsonVariation.gridSelected)
      setVariationNone(jsonVariation.variationNone)
      if (typeof jsonVariation.image === 'string') setImage(jsonVariation.image)
      localStorage.removeItem('variation-saved')
    }
  }

  const saveLocal = () => {
    localStorage.setItem(
      'variation-saved',
      JSON.stringify({
        status,
        showPromotionalPrice,
        products,
        locations,
        productId,
        productSelected,
        locationId,
        selectedGrid,
        grids,
        gridList,
        gridConfirmed,
        sku,
        referenceCode,
        colorCode,
        gtin,
        mpn,
        ncm,
        costPrice,
        price,
        promotionalPrice,
        weight,
        height,
        width,
        deep,
        stockSituation,
        outStockSituation,
        inventory,
        minStock,
        gridSelected,
        variationNone,
        image,
      })
    )
  }

  useEffect(() => {
    saveLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    status,
    showPromotionalPrice,
    products,
    locations,
    productId,
    productSelected,
    locationId,
    selectedGrid,
    grids,
    gridList,
    gridConfirmed,
    sku,
    referenceCode,
    colorCode,
    gtin,
    mpn,
    ncm,
    costPrice,
    price,
    promotionalPrice,
    weight,
    height,
    width,
    deep,
    stockSituation,
    outStockSituation,
    inventory,
    minStock,
    gridSelected,
    variationNone,
    image,
  ])

  return (
    <>
      <style>{`
        .variation-card-toggle {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 1px solid #e4e6ef;
          background-color: #f8f9fa;
          color: #7e8299;
          transition: all 0.2s ease;
        }
        .variation-card-toggle:hover {
          background-color: #eef3f7;
          border-color: #d7dbe2;
          color: #3f4254;
        }
        .variation-card-toggle:focus {
          box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.12);
        }
        .variation-image-column {
          min-width: 280px;
          max-width: 340px;
          width: 100%;
        }
        @media (max-width: 991.98px) {
          .variation-image-column {
            min-width: 100%;
            max-width: 100%;
          }
        }
      `}</style>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12 pb-5'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{`${i18n.t(
                  `buttons.create`
                )} ${i18n.t(`smart_order.variation`)}`}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `general.fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes`
                  )}
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div className='d-flex justify-content-between flex-wrap w-100 gap-5'>
                <div className='me-5' style={{flex: 1}}>
                  <CollapsibleCard title='Configuração Inicial'>
                    <div className='row g-4'>
                      <div className='col-lg-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          search
                          value={productSelected}
                          change={(event: SelectType) => {
                            setCanAlert(true)
                            setProductSelected(event)
                            setProductId(parseInt(event.value))
                          }}
                          label={i18n.t(`smart_order.product`)}
                          options={products.map((product) => ({
                            select: product.name,
                            value: product.id,
                          }))}
                        />
                      </div>
                      <div className='col-lg-6'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          value={locationId}
                          change={setLocationId}
                          label={i18n.t(`smart_order.modality`)}
                          options={locations.map((location) => ({
                            select: location.name,
                            value: location.id,
                          }))}
                        />
                      </div>
                    </div>

                    {!gridConfirmed && (
                      <div className='mt-4'>
                        <Input
                          inputAttr={{
                            type: 'checkbox',
                          }}
                          value={variationNone}
                          checked={variationNone}
                          disabled={!(loginInfo.plugintype === 'fashion')}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setVariationNone(value)
                            setGridList([])
                            setGridSelected({
                              VARIATION: 'NONE',
                            })
                          }}
                          label={i18n.t(`smart_order.no_variation`)}
                        />
                      </div>
                    )}

                    {!variationNone && (
                      <div className='mt-4'>
                        {!gridConfirmed && (
                          <>
                            <Input
                              inputAttr={{
                                type: 'select-multiple',
                              }}
                              change={setSelectedGrid}
                              label={i18n.t(`smart_order.grids`)}
                              options={grids.map((grid) => ({
                                select: grid.name,
                                value: grid.id,
                              }))}
                            />
                            <div className='d-flex align-items-center gap-3 flex-wrap mt-2'>
                              <Button
                                text={i18n.t(`buttons.add_grade`)}
                                color='primary'
                                size='small'
                                btnAttr={{
                                  type: 'button',
                                }}
                                disabled={gridConfirmed}
                                click={() => addToGridList()}
                                btnClass='fw-bolder btn-success'
                              />
                              <Button
                                text={i18n.t(`buttons.confirm_grades`)}
                                color='primary'
                                size='small'
                                btnAttr={{
                                  type: 'button',
                                }}
                                disabled={gridConfirmed}
                                click={() => confirmGrid()}
                                btnClass='fw-bolder btn-success'
                              />
                            </div>
                          </>
                        )}

                        {gridList.length > 0 && (
                          <div className='mt-4'>
                            <label className='form-label fw-bold'>Grades selecionadas</label>
                            <div className='d-flex flex-wrap gap-3 mt-2'>
                              {gridList.map((grid) => (
                                <div
                                  key={grid.id}
                                  className='d-flex align-items-center px-3 py-2 rounded border border-gray-300 bg-light-primary'
                                >
                                  <span className='fw-semibold fs-7 text-gray-800'>
                                    {grid.name}
                                  </span>
                                  {!gridConfirmed && (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-icon btn-light-danger ms-2'
                                      onClick={() => removeToGridList(grid.id)}
                                      style={{width: '20px', height: '20px'}}
                                    >
                                      <i className='bi bi-x fs-7'></i>
                                    </button>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </CollapsibleCard>

                  {(gridConfirmed || variationNone) && (
                    <>
                      <CollapsibleCard title='Identificação' infoContent={identificationInfo}>
                        <div className='row g-4'>
                          <div className='col-12'>
                            <div className='form-group'>
                              <label className='form-label fw-normal'>
                                {i18n.t(`smart_order.variation_product`)}
                              </label>
                              <div className='input-group'>
                                <input
                                  type='text'
                                  className='form-control fw-normal'
                                  placeholder={i18n.t(`smart_order.variation`)}
                                  value={sku}
                                  onChange={(event) => {
                                    setCanAlert(true)
                                    setSku(event.target.value)
                                  }}
                                />
                                <div className='input-group-append'>
                                  <button
                                    className='btn btn-light'
                                    style={{
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                      zIndex: 0,
                                    }}
                                    type='button'
                                    onClick={() => generateSKU()}
                                  >
                                    {i18n.t(`buttons.generate_sku`)}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'text',
                              }}
                              placeholder={i18n.t(`smart_order.code`)}
                              label='Reference Code'
                              change={(value: string) => {
                                setCanAlert(true)
                                setReferenceCode(value)
                              }}
                              value={referenceCode}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'text',
                              }}
                              placeholder={i18n.t(`smart_order.color_code`)}
                              label='Código da Cor'
                              change={(value: string) => {
                                setCanAlert(true)
                                setColorCode(value)
                              }}
                              value={colorCode}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'text',
                              }}
                              placeholder='GTIN'
                              label='GTIN'
                              change={(value: string) => {
                                setCanAlert(true)
                                setGtin(value)
                              }}
                              value={gtin}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'text',
                              }}
                              placeholder='MPN'
                              label='MPN'
                              change={(value: string) => {
                                setCanAlert(true)
                                setMpn(value)
                              }}
                              value={mpn}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'text',
                              }}
                              placeholder='NCM'
                              label='NCM'
                              change={(value: string) => {
                                setCanAlert(true)
                                setNcm(value)
                              }}
                              value={ncm}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      <CollapsibleCard title='Preços' infoContent={pricesInfo}>
                        <div className='row g-4'>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'money',
                              }}
                              currency='BRL'
                              locale='pt-BR'
                              label={i18n.t(`smart_order.cost_price`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setCostPrice(value)
                              }}
                              value={costPrice}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'money',
                              }}
                              currency='BRL'
                              locale='pt-BR'
                              label={i18n.t(`smart_order.sell_price`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setPrice(value)
                              }}
                              value={price}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'money',
                              }}
                              currency='BRL'
                              locale='pt-BR'
                              label={i18n.t(`smart_order.promotional_price`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setPromotionalPrice(value)
                              }}
                              value={promotionalPrice}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      <CollapsibleCard title='Dimensões' infoContent={dimensionsInfo}>
                        <div className='row g-4'>
                          <div className='col-md-6 col-xl-3'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder=''
                              label={i18n.t(`smart_order.weight`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setWeight(value)
                              }}
                              value={weight}
                            />
                          </div>
                          <div className='col-md-6 col-xl-3'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder=''
                              label={i18n.t(`smart_order.height`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setHeight(value)
                              }}
                              value={height}
                            />
                          </div>
                          <div className='col-md-6 col-xl-3'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder=''
                              label={i18n.t(`smart_order.width`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setWidth(value)
                              }}
                              value={width}
                            />
                          </div>
                          <div className='col-md-6 col-xl-3'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder=''
                              label={i18n.t(`smart_order.depth`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setDeep(value)
                              }}
                              value={deep}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      <CollapsibleCard title='Disponibilidade' infoContent={availabilityInfo}>
                        <div className='row g-4'>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={stockSituation}
                              change={setStockSituation}
                              label={i18n.t(`smart_order.availability`)}
                              options={[
                                {select: 'Disponibilidade imediata', value: 0},
                                {select: 'Disponibilidade para 1 dia útil', value: 1},
                                {select: 'Disponibilidade para 2 dias úteis', value: 2},
                                {select: 'Disponibilidade para 3 dias úteis', value: 3},
                                {select: 'Disponibilidade para 4 dias úteis', value: 4},
                                {select: 'Disponibilidade para 5 dias úteis', value: 5},
                                {select: 'Disponibilidade para 6 dias úteis', value: 6},
                                {select: 'Disponibilidade para 7 dias úteis', value: 7},
                                {select: 'Disponibilidade para 8 dias úteis', value: 8},
                                {select: 'Disponibilidade para 9 dias úteis', value: 9},
                                {select: 'Disponibilidade para 10 dias úteis', value: 10},
                                {select: 'Disponibilidade para 15 dias úteis', value: 15},
                                {select: 'Disponibilidade para 20 dias úteis', value: 20},
                                {select: 'Disponibilidade para 25 dias úteis', value: 25},
                                {select: 'Disponibilidade para 30 dias úteis', value: 30},
                                {select: 'Disponibilidade para 45 dias úteis', value: 45},
                                {select: 'Disponibilidade para 60 dias úteis', value: 60},
                                {select: 'Disponibilidade para 90 dias úteis', value: 90},
                              ]}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={outStockSituation}
                              change={setOutStockSituation}
                              label={i18n.t(`smart_order.when_product_stock`)}
                              options={[
                                {select: 'Continuar vendendo normalmente', value: 0},
                                {select: 'Tornar o produto indisponível', value: -1},
                                {select: 'Mudar a disponibilidade para 1 dia útil', value: 1},
                                {select: 'Mudar a disponibilidade para 2 dias úteis', value: 2},
                                {select: 'Mudar a disponibilidade para 3 dias úteis', value: 3},
                                {select: 'Mudar a disponibilidade para 4 dias úteis', value: 4},
                                {select: 'Mudar a disponibilidade para 5 dias úteis', value: 5},
                                {select: 'Mudar a disponibilidade para 6 dias úteis', value: 6},
                                {select: 'Mudar a disponibilidade para 7 dias úteis', value: 7},
                                {select: 'Mudar a disponibilidade para 8 dias úteis', value: 8},
                                {select: 'Mudar a disponibilidade para 9 dias úteis', value: 9},
                                {select: 'Mudar a disponibilidade para 10 dias úteis', value: 10},
                                {select: 'Mudar a disponibilidade para 15 dias úteis', value: 15},
                                {select: 'Mudar a disponibilidade para 20 dias úteis', value: 20},
                                {select: 'Mudar a disponibilidade para 25 dias úteis', value: 25},
                                {select: 'Mudar a disponibilidade para 30 dias úteis', value: 30},
                                {select: 'Mudar a disponibilidade para 45 dias úteis', value: 45},
                                {select: 'Mudar a disponibilidade para 60 dias úteis', value: 60},
                                {select: 'Mudar a disponibilidade para 90 dias úteis', value: 90},
                              ]}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      <CollapsibleCard title='Estoque' infoContent={stockInfo}>
                        <div className='row g-4'>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder='Informe a quantidade'
                              label={i18n.t(`smart_order.stock`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setInventory(value)
                              }}
                              value={inventory}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              placeholder='Informe a quantidade'
                              label={i18n.t(`smart_order.min_stock`)}
                              change={(value: number) => {
                                setCanAlert(true)
                                setMinStock(value)
                              }}
                              value={minStock}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      <CollapsibleCard title='Status' infoContent={statusInfo}>
                        <div className='row g-4'>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={status}
                              change={setStatus}
                              label='Status'
                              options={[
                                {select: i18n.t(`general.active`), value: true},
                                {select: i18n.t(`general.inactive`), value: false},
                              ]}
                            />
                          </div>
                          <div className='col-md-6 col-xl-4'>
                            <Input
                              inputAttr={{
                                type: 'select',
                              }}
                              value={showPromotionalPrice}
                              change={setShowPromotionalPrice}
                              label='Exibir preço promocional'
                              options={[
                                {select: i18n.t(`general.active`), value: true},
                                {select: i18n.t(`general.inactive`), value: false},
                              ]}
                            />
                          </div>
                        </div>
                      </CollapsibleCard>

                      {!variationNone && (
                        <CollapsibleCard title='Atributos da Variação' infoContent={attributesInfo}>
                          <div className='row g-4'>
                            {gridList.map((grid) => (
                              <div className='col-md-6 col-xl-4' key={grid.id}>
                                <Input
                                  inputAttr={{
                                    type: 'select',
                                  }}
                                  change={(valueVariation: string) => {
                                    setCanAlert(true)
                                    makeVariationContext(grid.name, valueVariation)
                                  }}
                                  label={grid.name}
                                  options={Object.entries(JSON.parse(grid.variation)).map(
                                    (variation: any) => ({
                                      select: variation[1],
                                      value: variation[1],
                                    })
                                  )}
                                />
                              </div>
                            ))}
                          </div>
                        </CollapsibleCard>
                      )}
                    </>
                  )}
                </div>

                {(gridConfirmed || variationNone) && (
                  <div className='variation-image-column'>
                    <CollapsibleCard title={i18n.t(`smart_order.image`)}>
                      <div className='d-flex justify-content-center w-100'>
                        <div className='px-10 py-5'>
                          <Input
                            inputAttr={{
                              type: 'image',
                            }}
                            label={i18n.t(`smart_order.image`)}
                            value={image}
                            change={(value: BaseSyntheticEvent) => {
                              setCanAlert(true)
                              setImage(value ? value.target.files[0] : null)
                            }}
                          />
                        </div>
                      </div>
                    </CollapsibleCard>
                  </div>
                )}
              </div>

              <div className='card px-10 py-4 col-12 mb-5'>
                <div className='d-flex justify-content-between w-100'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate(-1)}
                    btnClass='fw-bolder'
                  />
                  <Button
                    text={i18n.t(`buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      setCanAlert(false)
                      createVariation()
                    }}
                    btnClass='fw-bolder'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const CriarVariacoes: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`smart_order.variations`), path: 'variation', isActive: true},
          {title: i18n.t(`buttons.create`), path: 'variation/criar', isActive: true},
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.variations`)}`}
      </PageTitle>
      <CriarVariacoesContent />
    </>
  )
}

export {CriarVariacoes}
